module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/soapBars@3x_6770c7.png";